import { Component, Input, OnInit } from '@angular/core'
import { ObjectUtils } from '../../../../../shared/utils/object-utils'
import { ContentResultItem } from '../../../types'

@Component({
  selector: 'mb-cms-search-result-item',
  templateUrl: './cms-search-result-item.component.html'
})
export class CmsSearchResultItemComponent implements OnInit {

  @Input() result: ContentResultItem | undefined
  @Input() additionalInfo: string | undefined
  title: string | undefined

  ngOnInit (): void {
    this.title = ObjectUtils.getInnerText(this.result?.title ?? '')
  }
}
